'use strict';

module.exports = [require('./bellNumbers'), require('./composition'), require('./stirlingS2'), require('./catalan')];


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/function/combinatorics/index.js
// module id = j3W9
// module chunks = 0